import React from "react";
import { Table } from "react-bootstrap";
import { Spinner } from "reactstrap";

const EmployeesMonthlyLeavesTable = (props) => {
	return (
		<>
			<Table className="reimbursement-table" responsive>
				<thead className="reimburse-thead">
					<tr>
						<td style={{ borderRadius: "10px 0px 0px 0px" }}>
							Sr#
						</td>

						<td colSpan={4} className="medical-col">
							Team Member
						</td>

						<td colSpan={2} className="medical-col">
							Annual Leaves
						</td>
						<td colSpan={2} className="homeInternet-col">
							Sick Leaves
						</td>
						<td colSpan={2} className="mobile-col">
							Customer Compensation
						</td>
						<td className="mobile-col">In Process</td>
						<td
							style={{ borderRadius: "0px 10px 0px 0px" }}
							colSpan={3}
						>
							Total
						</td>
					</tr>
					<tr className="sub-thead">
						<td></td>
						<td className="medical-col" colSpan={4}></td>
						<td className="medical-col">Availed</td>
						<td className="medical-col">Remaining</td>
						<td className="medical-col">Availed</td>
						<td className="medical-col">Remaining</td>
						<td className="mobile-col">
							Availed (Customer Approved)
						</td>
						<td>Remaining</td>
						<td className="mobile-col">Not Approved</td>
						<td className="mobile-col">Absentees</td>
						<td className="mobile-col">Availed</td>
						<td>Remaining</td>
					</tr>
				</thead>
				<tbody>
					{props.MonthlyReimbursementTableLoader ? (
						<tr>
							<td
								data-toggle="collapse"
								colSpan="20"
								className="noRecordContainer"
							>
								<Spinner />
							</td>
						</tr>
					) : props.monthlyLeaves?.length === 0 ? (
						<tr>
							<td
								data-toggle="collapse"
								colSpan="20"
								className="noRecordContainer"
							>
								<div
									className="font-weight-bold mt-4"
									bis_skin_checked="1"
								>
									<span className="noRecord">
										NO RECORD FOUND
									</span>
								</div>
							</td>
						</tr>
					) : (
						props.monthlyLeaves?.map((data, index) => {
							const {
								employeeName,
								annualAvailed,
								annualLeave,
								compensationAvailed,
								compensationLeave,
								sickAvailed,
								sickLeave,
								totalAvailed,
								pendingLeaves,
								absentees,
								totalRemaining,
							} = data;
							return (
								<tr key={index}>
									<td>#{index + 1}</td>

									<td className="medical-col" colSpan={4}>
										{employeeName}
									</td>
									<td className="medical-col">
										{annualAvailed}
									</td>
									<td className="medical-col">
										{annualLeave}
									</td>
									<td className="medical-col">
										{sickAvailed}
									</td>
									<td className="homeInternet-col">
										{sickLeave}
									</td>
									<td className="homeInternet-col">
										{compensationAvailed}
									</td>
									<td className="mobile-col">
										{compensationLeave}
									</td>
									<td className="mobile-col">
										{pendingLeaves}
									</td>
									<td className="mobile-col">{absentees}</td>
									<td className="mobile-col">
										{totalAvailed}
									</td>
									<td colSpan={2} className="medical-col">
										{totalRemaining}
									</td>
								</tr>
							);
						})
					)}
				</tbody>
			</Table>
		</>
	);
};
export default EmployeesMonthlyLeavesTable;
